import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import HotelHitImage from './HotelHitImage.js';
import HotelHitImageContent from './HotelHitImageContent.js';
import HotelHitContent from './HotelHitContent.js';
import HotelHitConceptRow from './HotelHitConceptRow.js';
import HotelHitBottomLink from './HotelHitBottomLink.js';
import { HotelHitContainer, HotelHitTabletLink } from './styles/hotelHit.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var _excluded = ["className", "imageContent", "content", "href", "onSelect", "buttonHref", "onOpenGallery", "siteId", "lazy"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var HotelHit = function HotelHit(_ref) {
  var className = _ref.className,
    _ref$imageContent = _ref.imageContent,
    picture = _ref$imageContent.picture,
    concept = _ref$imageContent.concept,
    tags = _ref$imageContent.tags,
    lolloAndBernie = _ref$imageContent.lolloAndBernie,
    showGallery = _ref$imageContent.showGallery,
    content = _ref.content,
    href = _ref.href,
    onSelect = _ref.onSelect,
    buttonHref = _ref.buttonHref,
    onOpenGallery = _ref.onOpenGallery,
    siteId = _ref.siteId,
    lazy = _ref.lazy,
    rest = _objectWithoutProperties(_ref, _excluded);
  var conceptRowText = content.conceptRowText,
    bottomRowLink = content.bottomRowLink;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [conceptRowText && /*#__PURE__*/jsx(HotelHitConceptRow, {
      conceptRowText: conceptRowText
    }), /*#__PURE__*/jsxs(HotelHitContainer, {
      className: className,
      children: [(href || onSelect) && /*#__PURE__*/jsx(HotelHitTabletLink, {
        href: href,
        onClick: onSelect,
        rel: "nofollow"
      }), /*#__PURE__*/jsx(HotelHitImage, {
        picture: picture,
        lazy: lazy,
        children: /*#__PURE__*/jsx(HotelHitImageContent, {
          concept: concept,
          tags: tags,
          lolloAndBernie: lolloAndBernie,
          href: href,
          onSelect: onSelect,
          onOpenGallery: onOpenGallery,
          showGallery: showGallery,
          siteId: siteId,
          lazy: lazy
        })
      }), /*#__PURE__*/jsx(HotelHitContent, _objectSpread({
        content: content,
        href: href,
        onSelect: onSelect,
        buttonHref: buttonHref,
        siteId: siteId,
        lazy: lazy
      }, rest))]
    }), bottomRowLink && /*#__PURE__*/jsx(HotelHitBottomLink, _objectSpread({}, bottomRowLink))]
  });
};
HotelHit.defaultProps = {
  className: null,
  imageContent: null,
  content: null,
  href: null,
  onSelect: null,
  onOpenGallery: null,
  buttonHref: null,
  siteId: 1,
  lazy: false
};
var HotelHit$1 = HotelHit;

export { HotelHit$1 as default };
//# sourceMappingURL=HotelHit.js.map
